import TreatmentsSectionImplementation from '../implementation/sections/TreatmentsSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiTreatmentsSectionDTO,
  TreatmentsSectionDTO,
} from '@lib/strapi/dtos/components/sections/treatmentsSection.dto';

const TreatmentsSection = (props: ComponentProps<TreatmentsSectionDTO>) => {
  return <TreatmentsSectionImplementation {...props}></TreatmentsSectionImplementation>;
};

export default TreatmentsSection;
